/**
 * @license examspark/question-player v.0.1.0
 * Copyright (c) ExamSpark.
 */

import Question from "./Question";
import QuestionContext from "./QuestionContext";

export { useMarchingBorder } from "./interactions/common/image-map/useMarchingBorder";
export {
  MAX_NUMBER_OF_SHADEABLES,
  MAX_NUMBER_OF_SLICES,
} from "./interactions/fraction-model/FractionModel";
export { ExamFeatureContext } from "./context/ExamFeatureContext";

export {
  CartesianModePrompt as CartesianInequalityModePrompt,
  ShapeControlButtons as CartesianInequalityShapeControlButtons,
} from "./interactions/common/graph/cartesian/CartesianInequalityControls";

export { default as Canvas } from "./Canvas";
export { default as Context } from "./Context";
export { default as CartesianGraph } from "./interactions/common/graph/cartesian/CartesianGraph";
export { default as CartesianInequality } from "./interactions/common/graph/cartesian/CartesianInequality";
export { default as NumberLineGraph } from "./interactions/common/graph/number-line/NumberLineGraph";
export { default as BarChart } from "./interactions/common/graph/bar-graph/BarChart";
export { default as LineChart } from "./interactions/common/graph/line-chart/LineChart";
export { default as EquationEntry } from "./interactions/tools/EquationEntry";
export * as NumberLineButtons from "./interactions/common/graph/number-line/icons";
export { QuestionContext };
export default Question;

export * from "./context/reducer";

export { default as ItemFontScaling } from "./ItemFontScaling";
